export default __webpack_public_path__ + "static/media/DashWayside.289d01c8.svg";